import React, { useState } from 'react';
import { Box, Divider, Typography } from '@material-ui/core';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { useAsync } from 'react-use';

import CloseButton from 'components/CustomButtons/CloseButton';
import Loader from 'components/Loader';
import GoErpApp from 'components/GoErpApp/GoErpApp';
import { CUSTOMER_SERVICE_PAGE } from 'plugins/mm/constants';
import { generateToken } from 'plugins/mm/utils';
import { getSelectedCustomerID } from 'reducers/customerSearch';
import { getConfiguration } from 'plugins/mm/configuration';
import { getUserLoggedIn, getClientCode } from 'reducers/Login';

function CustomerService({ onClose }) {
  const { t } = useTranslation('customerService');

  const customerId = useSelector(getSelectedCustomerID);
  const user = useSelector(getUserLoggedIn);
  const clientCode = useSelector(getClientCode);
  const { crmServiceTokenSalt } = useSelector(getConfiguration);

  const [loading, setLoading] = useState(false);

  const {
    loading: loadingSearchParams,
    value: urlSearchParams,
  } = useAsync(async () => {
    const token = await generateToken(customerId, crmServiceTokenSalt);
    return new URLSearchParams({
      customerId,
      userId: user.userID,
      userName: user.userName,
      clientCode,
      t: token,
    }).toString();
  }, [clientCode, crmServiceTokenSalt, user.userID, user.userName, customerId]);

  function handleLoad() {
    setLoading(false);
  }

  return (
    <div data-testid="CustomerService">
      <Box display="flex" alignItems="center" padding="1rem">
        <Typography variant="h5">{t('title')}</Typography>
        <Box flexGrow={1} />
        <CloseButton action={onClose} />
      </Box>
      <Divider />
      <Box>
        <Loader show={loading || loadingSearchParams} block>
          {loadingSearchParams ? null : (
            <GoErpApp
              title={t('title')}
              url={`/${CUSTOMER_SERVICE_PAGE}?${urlSearchParams}`}
              onStartLoading={() => setLoading(true)}
              onLoad={handleLoad}
              iframeProps={{
                style: {
                  width: '100%',
                  height: 'calc(100vh - 180px)',
                },
              }}
            />
          )}
        </Loader>
      </Box>
    </div>
  );
}

export default CustomerService;
